import React from "react";
import Sidebar from "./Sidebar";
import AttendanceCard from "./AttendanceCard";
import LeaveRequests from "./LeaveRequests";
import HolidayList from "./HolidayList";
import EmployeeProfile from "./EmployeeProfile";
import EmployeeAnnouncements from "./EmployeeAnnouncements";
import bgImg from '../assets/lighting.jpg'; // adjust path if component is deeper

function EmployeeDashboard() {
  const employee = JSON.parse(localStorage.getItem("employee") || "{}");

  // Make tab persist with localStorage. Pick any default (e.g. "dashboard").
  const [activePage, setActivePage] = React.useState(
    () => localStorage.getItem("employeeActiveTab") || "dashboard"
  );

  // Update localStorage whenever tab changes.
  React.useEffect(() => {
    localStorage.setItem("employeeActiveTab", activePage);
  }, [activePage]);

  return (
    <div style={{
      position: "relative",
      minHeight: "100dvh",
      backgroundImage: `url(${bgImg})`,
      backgroundSize: "cover",
    }}>
      {/* Foreground app UI */}
      <div className="dashboard-layout" style={{ display: "flex", position: "relative", zIndex: 1 }}>
        <Sidebar employee={employee} activePage={activePage} setActivePage={setActivePage} />
        <div style={{ flex: 1 }}>
          {activePage === "dashboard" && (
            <div>
              <EmployeeProfile username={employee.username} />
            </div>
          )}
          {activePage === "attendance" && <AttendanceCard employee={employee} />}
          {activePage === "leave" && <LeaveRequests employee={employee} />}
          {activePage === "holiday" && <HolidayList employee={employee} />}
          {activePage === "employeeannouncements" && (
            <EmployeeAnnouncements employee={employee} />
          )}
        </div>
      </div>
    </div>
  );
}

export default EmployeeDashboard;
